import Utility from '@/utils/Utility'

export default {
  name: 'TypeSound',
  props: {
    model: {
      type: Object,
      required: true,
    }
  },
  mounted () {

  },
  computed: {
    showSoundFile() {
      return this.model.soundFile
    },
    soundFile() {
      return this.model.soundFile
    }
  },
}
